var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("We couldn't find what you are looking for."),_c('br'),_c('br'),_vm._v(" Try "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("starting over at the beginning")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }